module.exports = __webpack_public_path__ + "img/app_logo.ffefb31c.png";